<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex align-items-center" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                        <button class="ms-5" *ngIf="alta" mat-flat-button color="accent" (click)="cotizacion(0,1)">
                            <mat-icon>add</mat-icon>
                            Nueva cotización</button>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div class="container-custom-content animate__animated animate__fadeIn  buscador-pedidos">

    <mat-accordion>
        <mat-expansion-panel [expanded]="true" hideToggle  #panel="matExpansionPanel">
            
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Parametros de búsqueda
                </mat-panel-title>
    <mat-icon
      style="color: white; margin-left: auto;"
      [style.transform]="panel.expanded ? 'rotate(180deg)' : 'rotate(0deg)'"
      style="transition: transform 0.3s ease; color: white; margin-left: auto;"
    >
      expand_more
    </mat-icon>

            </mat-expansion-panel-header>
            <div class="container-fluid mt-4">

                <div class="row align-items-center">

                    <!-- <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" [hidden]="!selectRegiones">
                        <app-selector-regiones #selectorRegion (regionEmitida)="recibirRegionEmitida($event)"
                            [regionRecibida]="regionSeleccionada">
                        </app-selector-regiones>
                    </div>


                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" [hidden]="selectRegiones"></div> -->


                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.FechaDesde}}</mat-label>
                            <input readonly matInput [matDatepicker]="picker" [(ngModel)]="buscador.fDesde">

                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker [(ngModel)]="buscador.fDesde" #picker></mat-datepicker>

                        </mat-form-field>
                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">

                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.FechaHasta}}</mat-label>
                            <input readonly matInput [matDatepicker]="picker2" [(ngModel)]="buscador.fHasta">

                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker [(ngModel)]="buscador.fHasta" #picker2></mat-datepicker>

                        </mat-form-field>

                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.BuscarCliente}}</mat-label>
                            <input (change)="handleEmptyInputCliente($event)" matInput [matAutocomplete]="autoC"
                                [formControl]="fcAutocompleteCliente" placeholder="Nro. cliente, nombre, etc...">
                            <button type="button" matSuffix mat-icon-button matTooltip="Limpiar cliente seleccionado"
                                (click)="limpiarCliente(true)">

                                <mat-icon color="accent-darker">close</mat-icon>
                            </button>

                            <mat-autocomplete #autoC="matAutocomplete"
                                (optionSelected)='seleccionarCliente($event.option.value)'
                                [displayWith]="getOptionTextCliente">
                                <mat-option *ngIf="loadingFcAutocompleteCliente"
                                    class="is-loading">Cargando...</mat-option>
                                <ng-container *ngIf="!loadingFcAutocompleteCliente">
                                    <mat-option *ngFor="let cl of clientesEncontrados" [value]="cl">
                                        {{cl.displayValue}}
                                    </mat-option>
                                </ng-container>
                            </mat-autocomplete>

                        </mat-form-field>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.Cliente}} Seleccionado</mat-label>
                            <input type="text" *ngIf="clienteSeleccionado != null" [disabled]="true" matInput
                                [value]="clienteSeleccionado.displayValue">
                            <input type="text" *ngIf="clienteSeleccionado == null" [disabled]="true" matInput
                                [value]="">
                        </mat-form-field>

                    </div>

                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <app-selector-estado-pedidos #selectorEstadoPedido
                            (estadoEmitido)="recibirEstadoEmitido($event)" [estadoRecibido]="estadoSeleccionado">
                        </app-selector-estado-pedidos>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                        <mat-form-field color="accent-darker" appearance="outline">
                            <mat-label>{{Etiquetas.NroCotizacion}}</mat-label>
                            <input numbersOnly [(ngModel)]="buscador.nroPedido" type="text" matInput>
                        </mat-form-field>
                    </div>


                </div>
            </div>
        </mat-expansion-panel>

    </mat-accordion>

    <div class="row align-items-center mt-3 mb-3">
        <div class="mat-toolbar-custom">
            <mat-toolbar>
                <mat-toolbar-row>

                    <button (click)="buscar(0)" mat-flat-button color="accent">
                        <mat-icon>search</mat-icon>
                        Buscar</button>


                </mat-toolbar-row>

            </mat-toolbar>

        </div>

    </div>



</div>
<div class="container-fluid">
    <div class="row align-items-center justify-content-evenly">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <mat-form-field color="accent-darker" appearance="standard">
                <mat-label>{{Etiquetas.Buscar}}</mat-label>
                <input matInput (keyup)="applyFilter($event)" #input>
            </mat-form-field>
            <div class="mat-table-pedidos">
                <table mat-table matTableResponsive [dataSource]="dataSource" matSort #matSort="matSort"
                    matSortActive="nroPedido" matSortDirection="desc" multiTemplateDataRows class="mat-elevation-z8">
                    <!-- Columna para el botón de expandir -->

                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Acciones}} </th>
                        <td mat-cell *matCellDef="let c">
                            <div>
                                <button *ngIf="c.editar" (click)="cotizacion(c.codigo,2)"
                                    matTooltip="{{Tooltips.Editar}}" mat-icon-button color="primary-darker">
                                    <mat-icon color="accent-darker">edit</mat-icon>
                                </button>

                                <button *ngIf="c.ver" (click)="cotizacion(c.codigo,3)" matTooltip="{{Tooltips.Ver}}"
                                    mat-icon-button color="primary-darker">
                                    <mat-icon color="accent-darker">visibility</mat-icon>
                                </button>
                                <button
                                    *ngIf="alta && (c.usuarioRedSolicitante == this.userName || this.isInRole('ADMVENTAS') || this.isInRole('ADM LOCAL') || this.isInRole('ADM'))"
                                    (click)="copiarPedido(c.codigo)" matTooltip="{{Tooltips.Copiar}}" mat-icon-button
                                    color="primary-darker">
                                    <mat-icon color="accent-darker">content_copy</mat-icon>
                                </button>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="nroPedido">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NroCotizacion}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.nroPedido}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="fechaCreacion">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.FechaCreacion}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.fechaCreacion | date:'dd/MM/yyyy HH:mm'}}
                        </td>
                    </ng-container>
                    <!-- <ng-container matColumnDef="nroOrdenSAP">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NroOrdenSAP}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.nroOrdenSAP}}
                        </td>
                    </ng-container> -->

                    <ng-container matColumnDef="nombreCliente">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.NombreCliente}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.nombreCliente}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="estado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.Estado}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            <div [ngClass]="clasePorEstado(c.idEstado)">
                                {{c.estado}}

                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="fechaEstado">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.FechaEstado}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.fechaEstado | date:'dd/MM/yyyy HH:mm'}}
                        </td>
                    </ng-container>


                    <ng-container matColumnDef="terminoPago">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.TerminoPago}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.terminoPago}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="idZonaVendedor">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.IdZonaVendedor}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.nombreVendedor}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.TotalUSD}} 
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.total | number : '1.2-2'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="totalLocal">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            {{Etiquetas.TotalLocal}}
                        </th>
                        <td mat-cell *matCellDef="let c">
                            {{c.totalLocal | number : '1.0-0'}}
                        </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <ng-container matColumnDef="expand">
                        <th mat-header-cell *matHeaderCellDef aria-label="row actions">Pedidos Generados</th>
                        <td mat-cell *matCellDef="let element">
                            <button *ngIf="element.idEstado == 4" mat-icon-button aria-label="expand row"
                                (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
                                <mat-icon *ngIf="expandedElement !== element">keyboard_double_arrow_down</mat-icon>
                                <mat-icon *ngIf="expandedElement === element">keyboard_double_arrow_up</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                    <ng-container matColumnDef="expandedDetail">
                        <div>
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                                <div *ngIf="element.idEstado == 4" class="example-element-detail"
                                    [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            <td *ngFor="let pedido of element.pedidoCotizados">
                                <div class="">
                                    <button (click)="IrAlPedido(pedido.codigoPedido,3,pedido.idTipoOrden)"
                                        matTooltip="Ir al Pedido" mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">launch</mat-icon>
                                    </button>
                                    Nro. Pedido: {{ pedido.nroPedido }}, Tipo de Orden: {{ pedido.tipoOrden }},
                                    <a [ngClass]="clasePorEstadoPedidos(pedido.idTipoOrden, pedido.codigoEstado)">{{Etiquetas.Estado}}:
                                        {{pedido.estado}}</a>
                                </div>
                            </td>
                            <!-- {{element.PedidosCotizadosString}} -->
                        </div>
                        </td>
            </div>
            </ng-container>


            <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element">
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']; when: isDetailRow" class="example-detail-row">
            </tr>

            <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                    {{Etiquetas.SinRegistros}}
                </td>
            </tr>
            </table>

            <mat-paginator #matPaginator="matPaginator" [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
            </mat-paginator>
        </div>

    </div>

</div>

</div>